"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "@/components/theme";

// Wraps the app with the Auth.js session context (so client components like the
// nav bar can read the signed-in user) and the theme context (light/dark/system,
// class-based). No-flash is handled by THEME_INIT_SCRIPT in the server layout.
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <SessionProvider>{children}</SessionProvider>
    </ThemeProvider>
  );
}
